import React, { useEffect } from 'react';
import { useAuth0 } from '@auth0/auth0-react';
import { confirmCheckoutSession } from '../Services/SheafService';
const SheafSuccess = () => {
  const { getAccessTokenSilently } = useAuth0();

  useEffect(() => {
    const sessionId = new URLSearchParams(window.location.search).get('session_id');
    const finalize = async () => {
      try {
        const token = await getAccessTokenSilently({
          authorizationParams: { audience: process.env.REACT_APP_API_AUDIENCE },
        });
        await confirmCheckoutSession(token, sessionId);
      } catch (err) {
        console.error('Error confirming checkout session:', err);
      }
    };
    if (sessionId) finalize();
  }, [getAccessTokenSilently]);

  return (
    <div className="p-4">
      <h2>Payment Successful</h2>
      <p>Your payment was received. Your Sheaf balance will update after Stripe confirms the transaction.</p>
    </div>
  );
};

export default SheafSuccess;
